import React from 'react';
import { useSearchParams } from 'react-router-dom';

import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';
import IndexPaginationNav from 'buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import MembersIndexCard from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCard';
import MembersIndexCardLoading from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCardLoading';

import { validatePageParam } from 'buyside/util/numbers';

import { usePublicUserFollowingQuery } from 'interfaces/graphql-typings';

const PublicUserFollowing: React.FC<{
  activeFollowedUsersCount: number;
  canViewUserDetails: boolean;
  safeFirstName: string;
  userId: string;
}> = ({ activeFollowedUsersCount, canViewUserDetails, safeFirstName, userId }) => {
  const [searchParams] = useSearchParams();
  const page = validatePageParam(searchParams);

  const { data, error, loading } = usePublicUserFollowingQuery({
    variables: { userId, page },
    skip: !activeFollowedUsersCount
  });

  if (error) throw error;

  if (!activeFollowedUsersCount)
    return <AlertStatic>{safeFirstName} is not following anyone.</AlertStatic>;

  const { followingList } = data?.userLookUp || {};

  return (
    <>
      {loading
        ? [...Array(3)].map((_, idx) => (
            <MembersIndexCardLoading key={`following-skeleton-${idx}`} />
          ))
        : null}
      {followingList?.edges?.map(edge =>
        edge?.node ? (
          <MembersIndexCard
            key={`following-${edge.node.id}`}
            canViewUserDetails={canViewUserDetails}
            node={edge.node}
          />
        ) : null
      )}
      <IndexPaginationNav
        loading={loading}
        resultCount={activeFollowedUsersCount}
        resultLength={followingList?.edges?.length || 0}
        resultsPerPage={20}
      />
    </>
  );
};

export default PublicUserFollowing;
